var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isB2B && _vm.validInCurrentMarket
        ? _c("Price", {
            attrs: {
              product: _vm.product,
              priceClass: _vm.priceClass,
              priceExVatClass: _vm.priceExVatClass,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isB2B
        ? _c("B2B", {
            attrs: {
              product: _vm.product,
              priceClass: _vm.priceClass,
              priceExVatClass: _vm.priceExVatClass,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }